<template>
    <div class="delimiter" />
</template>

<style scoped lang="scss">
.delimiter {
    content: '';
    display: block;
    width: 300px;
    border-bottom: 2px solid #bb90a4;
}

@media only screen and (max-width: theme('screens.sm')) {
    .delimiter {
        width: 200px;
    }
}
</style>
